import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { PullGooglePlaceTypeModalActions } from './pull.google.place.type.modal.provider';
import { ButtonTriggerEvent } from '../../../common/components';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { ToggleAndDataSourceStore } from '../../../stores/hub.calendar.store';
import { LocalStorageService } from '../../../services/localStorageService';

@Component({
  templateUrl: './pull.google.place.type.modal.component.html',
  styleUrls: ['./pull.google.place.type.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PullGooglePlaceTypeModalComponent extends BaseComponent {
  public isSelectAll = false;
  public sources = [
    {
      text: 'Shopping',
      all: false,
      types: [
        {
          text: 'Store',
          value: 'store',
          checked: false,
        },
        {
          text: 'Bicycle store',
          value: 'bicycle_store',
          checked: false,
        },
        {
          text: 'Book store',
          value: 'book_store',
          checked: false,
        },
        {
          text: 'Shopping mall',
          value: 'shopping_mall',
          checked: false,
        },
        {
          text: 'Florist',
          value: 'florist',
          checked: false,
        },
        {
          text: 'Jewelry shop',
          value: 'jewelry_store',
          checked: false,
        },
        {
          text: 'Clothing store',
          value: 'clothing_store',
          checked: false,
        },
        {
          text: 'Shoe store',
          value: 'shoe_store',
          checked: false,
        },
        {
          text: 'Supermarket',
          value: 'supermarket',
          checked: false,
        },
        {
          text: 'Pet store',
          value: 'pet_store',
          checked: false,
        },
      ],
    },
    {
      text: 'Dining',
      all: false,
      types: [
        {
          text: 'Bakery',
          value: 'bakery',
          checked: false,
        },
        {
          text: 'Bar',
          value: 'bar',
          checked: false,
        },
        {
          text: 'Cafe',
          value: 'cafe',
          checked: false,
        },
        {
          text: 'Restaurant',
          value: 'restaurant',
          checked: false,
        },
        {
          text: 'Food',
          value: 'food',
          checked: false,
        },
      ],
    },
    {
      text: 'Accommodation',
      all: false,
      types: [
        {
          text: 'Campground',
          value: 'campground',
          checked: false,
        },
        {
          text: 'Lodging',
          value: 'lodging',
          checked: false,
        },
        {
          text: 'RV Park',
          value: 'rv_park',
          checked: false,
        },
        {
          text: 'Real Estate Agency',
          value: 'real_estate_agency',
          checked: false,
        },
      ],
    },
    {
      text: 'Activity',
      all: false,
      types: [
        {
          text: 'Amusement park',
          value: 'amusement_park',
          checked: false,
        },
        {
          text: 'Aquarium',
          value: 'aquarium',
          checked: false,
        },
        {
          text: 'Bowling Alley',
          value: 'bowling_alley',
          checked: false,
        },
        {
          text: 'Library',
          value: 'library',
          checked: false,
        },
        {
          text: 'Movie Theater',
          value: 'movie_theater',
          checked: false,
        },
        {
          text: 'Tourist Attraction',
          value: 'tourist_attraction',
          checked: false,
        },
        {
          text: 'Zoo',
          value: 'zoo',
          checked: false,
        },
      ],
    },
    {
      text: 'Arts & Culture',
      all: false,
      types: [
        {
          text: 'Art Gallery',
          value: 'art_gallery',
          checked: false,
        },
        {
          text: 'Museum',
          value: 'museum',
          checked: false,
        },
      ],
    },
    {
      text: 'Travel',
      all: false,
      types: [
        {
          text: 'Airport',
          value: 'airport',
          checked: false,
        },
        {
          text: 'Car Rental',
          value: 'car_rental',
          checked: false,
        },
        {
          text: 'Light Rail Station',
          value: 'light_rail_station',
          checked: false,
        },
        {
          text: 'Taxi Stand',
          value: 'taxi_stand',
          checked: false,
        },
        {
          text: 'Train Station',
          value: 'train_station',
          checked: false,
        },
        {
          text: 'Transit Station',
          value: 'transit_station',
          checked: false,
        },
        {
          text: 'Parking',
          value: 'parking',
          checked: false,
        },
        {
          text: 'Bus Station',
          value: 'bus_station',
          checked: false,
        },
        {
          text: 'Subway Station',
          value: 'subway_station',
          checked: false,
        },
      ],
    },
    {
      text: 'Entertainment',
      all: false,
      types: [
        {
          text: 'Movie Theater',
          value: 'movie_theater',
          checked: false,
        },
        {
          text: 'Night Club',
          value: 'night_club',
          checked: false,
        },
        {
          text: 'Tourist Attraction',
          value: 'tourist_attraction',
          checked: false,
        },
        {
          text: 'Casino',
          value: 'casino',
          checked: false,
        },
        {
          text: 'Stadium',
          value: 'stadium',
          checked: false,
        },
      ],
    },
    {
      text: 'Outdoor',
      all: false,
      types: [
        {
          text: 'Park',
          value: 'park',
          checked: false,
        },
      ],
    },
    {
      text: 'Wellness',
      all: false,
      types: [
        {
          text: 'Spa',
          value: 'spa',
          checked: false,
        },
        {
          text: 'Gym',
          value: 'gym',
          checked: false,
        },
      ],
    },
    {
      text: 'Other',
      all: false,
      types: [
        {
          text: 'Local Government Office',
          value: 'local_government_office',
          checked: false,
        },
        {
          text: 'Locality',
          value: 'locality',
          checked: false,
        },
        {
          text: 'Political',
          value: 'political',
          checked: false,
        },
      ],
    },
  ];
  public sourceOfAreaBusiness = [
    {
      text: 'Beauty',
      all: false,
      types: [
        {
          text: 'Beauty Salon',
          value: 'beauty_salon',
          checked: false,
        },
        {
          text: 'Hair Care',
          value: 'hair_care',
          checked: false,
        },
        {
          text: 'Spas',
          value: 'spa',
          checked: false,
        },
      ],
    },
    {
      text: 'Cars & Motor Services',
      all: false,
      types: [
        {
          text: 'Bicycle Store',
          value: 'bicycle_store',
          checked: false,
        },
        {
          text: 'Car Rental',
          value: 'car_rental',
          checked: false,
        },
        {
          text: 'Car Repair',
          value: 'car_repair',
          checked: false,
        },
        {
          text: 'Car Wash',
          value: 'car_wash',
          checked: false,
        },
        {
          text: 'Parking',
          value: 'parking',
          checked: false,
        },
      ],
    },
    {
      text: 'Cleaning Services',
      all: false,
      types: [
        {
          text: 'Laundry',
          value: 'laundry',
          checked: false,
        },
      ],
    },
    {
      text: 'Pet Services',
      all: false,
      types: [
        {
          text: 'Pet Store',
          value: 'pet_store',
          checked: false,
        },
        {
          text: 'Veterinary Care',
          value: 'veterinary_care',
          checked: false,
        },
      ],
    },
    {
      text: 'Convenience & Pharmacies',
      all: false,
      types: [
        {
          text: 'Pharmacy',
          value: 'pharmacy',
          checked: false,
        },
        {
          text: 'Drugstore',
          value: 'drugstore',
          checked: false,
        },
        {
          text: 'Convenience Store',
          value: 'convenience_store',
          checked: false,
        },
        {
          text: 'Supermarket',
          value: 'supermarket',
          checked: false,
        },
      ],
    },
    {
      text: 'Other Types',
      all: false,
      types: [
        {
          text: 'Real Estate Agency',
          value: 'real_estate_agency',
          checked: false,
        }, {
          text: 'Hospital',
          value: 'hospital',
          checked: false,
        },
      ],
    },
  ];
  public sourceOfLocalSecrets = [
    {
      text: 'Art and Culture',
      all: false,
      types: [
        {
          text: 'Art Galleries & Exhibitions',
          value: 'art_gallery',
          checked: false,
        },
        {
          text: 'Museums',
          value: 'museum',
          checked: false,
        },
        {
          text: 'Historical Sites',
          value: 'landmark',
          checked: false,
        },
        {
          text: 'Libraries',
          value: 'library',
          checked: false,
        },
        {
          text: 'Cinemas',
          value: 'movie_theater',
          checked: false,
        },
      ],
    },
    {
      text: 'Food and Drink',
      all: false,
      types: [
        {
          text: 'Restaurants',
          value: 'restaurant',
          checked: false,
        },
        {
          text: 'Bakeries & Cafes',
          value: 'bakery,cafe',
          checked: false,
        },
        {
          text: 'Delivery Food & Drinks',
          value: 'meal_delivery,meal_takeaway',
          checked: false,
        },
        {
          text: 'Sports Bars',
          value: 'bar',
          checked: false,
        },
        {
          text: 'Local Supermarkets',
          value: 'supermarket,liquor_store',
          checked: false,
        },
      ],
    },
    {
      text: 'Nightlife',
      all: false,
      types: [
        {
          text: 'Disco/Night Clubs',
          value: 'night_club',
          checked: false,
        },
        {
          text: 'Bars & Pubs',
          value: 'convenience_store',
          checked: false,
        },
        {
          text: 'Snacks & Fast Food',
          value: 'convenience_store',
          checked: false,
        },
      ],
    },
    {
      text: 'Trip & Tours Planner',
      all: false,
      types: [
        {
          text: 'Guided Tours',
          value: 'travel_agency',
          checked: false,
        },
        {
          text: 'Attractions / View Points',
          value: 'tourist_attraction',
          checked: false,
        },
        {
          text: 'Local Zoo',
          value: 'zoo',
          checked: false,
        },
        {
          text: 'Parks and Gardens',
          value: 'park',
          checked: false,
        },
        {
          text: 'Amusement Parks',
          value: 'amusement_park',
          checked: false,
        },
      ],
    },
    {
      text: 'Local Rental Services',
      all: false,
      types: [
        {
          text: 'Local Language Lessons',
          value: 'school',
          checked: false,
        },
        {
          text: 'Car Rental',
          value: 'car_rental',
          checked: false,
        },
        {
          text: 'Bicycle & Scooter Rental',
          value: 'bicycle_store',
          checked: false,
        },
        {
          text: 'Airport Shuttle',
          value: 'airport',
          checked: false,
        },
        {
          text: 'Taxi',
          value: 'taxi_stand',
          checked: false,
        },
        {
          text: 'Dry cleaner',
          value: 'laundry',
          checked: false,
        },
      ],
    },
    {
      text: 'Health & Personal Care',
      all: false,
      types: [
        {
          text: 'Barbershops, Hairdresser / Beauty Salon',
          value: 'beauty_salon,hair_care',
          checked: false,
        },
        {
          text: 'Hospital / Emergency',
          value: 'hospital',
          checked: false,
        },
        {
          text: 'Local Dentist',
          value: 'dentist',
          checked: false,
        },
        {
          text: 'Local Doctor',
          value: 'doctor',
          checked: false,
        },
        {
          text: 'Spa, Massage & Sauna',
          value: 'spa',
          checked: false,
        },
        {
          text: 'Pharmacies',
          value: 'drugstore',
          checked: false,
        },
        {
          text: 'Gym',
          value: 'gym',
          checked: false,
        },
      ],
    },
    {
      text: 'Accommodations',
      all: false,
      types: [
        {
          text: 'Hotels',
          value: 'lodging',
          checked: false,
        },
        {
          text: 'Campaigns',
          value: 'rv_park',
          checked: false,
        },
      ],
    },
    {
      text: 'Sports & Leisure',
      all: false,
      types: [
        {
          text: 'Local Gym',
          value: 'gym',
          checked: false,
        },
        {
          text: 'Nature & Adventure',
          value: 'natural_feature',
          checked: false,
        },
      ],
    },
    {
      text: 'Shopping',
      all: false,
      types: [
        {
          text: 'Local Art',
          value: 'art_gallery',
          checked: false,
        },
        {
          text: 'Souvenirs',
          value: 'store',
          checked: false,
        },
        {
          text: 'Wines and Alcohol',
          value: 'liquor_store',
          checked: false,
        },
        {
          text: 'Fashion',
          value: 'jewelry_store,clothing_store,shoe_store',
          checked: false,
        },
        {
          text: 'Shopping Centres',
          value: 'shopping_mall',
          checked: false,
        },
      ],
    },
  ];

  public localStorageCacheName = localStorageKeys.googlePlaceTypeToPull;

  constructor(
    private dialogRef: MatDialogRef<PullGooglePlaceTypeModalComponent>,
    private actions: PullGooglePlaceTypeModalActions,
    private toggleAndDataSourceStore: ToggleAndDataSourceStore,
    public imageService: ImageService
  ) {
    super();

    this.toggleAndDataSourceStore.toggleAndDataSourceCommand
      .takeUntil(this.isDestroyed)
      .subscribe((toggleCommand: HubVisitorToggleDataSource) => {
        const customDefaultPlaceCategory = LocalStorageService.getCustomDefaultPlaceCategoryFromLocalStorage();
        console.log('customDefaultPlaceCategory in pull google type', customDefaultPlaceCategory);
        // if (!customDefaultPlaceCategory || customDefaultPlaceCategory.useDefault) {
        if (toggleCommand && toggleCommand.dataSource) {
          if (toggleCommand.dataSource.businessType === 'area business') {
            this.sources = this.sourceOfAreaBusiness;
            this.localStorageCacheName = localStorageKeys.googlePlaceTypeToPullForAreaBusiness;
          }
          if (toggleCommand.dataSource.businessType === 'local secrets') {
            this.sources = this.sourceOfLocalSecrets;
            this.localStorageCacheName = localStorageKeys.googlePlaceTypeToPullForLocalSecrets;
          }
        }
        // }

        let lastTimeSelected = localStorage.getItem(this.localStorageCacheName);
        if (lastTimeSelected) {
          let selected = JSON.parse(lastTimeSelected);
          this.sources.forEach((x) => {
            x.types.filter((y) => selected.any((z) => z.value === y.value)).forEach((m) => (m.checked = true));
          });
        }
      });
  }

  public selectAll(mainType: any) {
    if (mainType) {
      mainType.types.forEach((x) => (x.checked = mainType.all));
      this.checkIsAll();
    }
  }

  public allIn() {
    this.sources.forEach((x) => {
      x.all = this.isSelectAll;
      x.types.forEach((y) => (y.checked = this.isSelectAll));
    });
  }

  public onSelect(mainType) {
    if (mainType) {
      if (mainType.types.any((x) => !x.checked)) {
        mainType.all = false;
      } else {
        mainType.all = true;
      }

      this.checkIsAll();
    }
  }

  public confirm() {
    let selected = [];
    this.sources.forEach((x) => {
      selected.push(
        ...x.types
          .filter((y) => y.checked)
          .map((z) => {
            return {text: z.text, value: z.value};
          })
      );
    });
    localStorage.setItem(this.localStorageCacheName, JSON.stringify(selected));
    this.actions.confirm(selected);
    this.dialogRef.close();
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  private checkIsAll() {
    this.isSelectAll = this.sources.every((x) => x.all);
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/pull.google.place.type.modal/pull.google.place.type.modal.component.ts